import styled from 'styled-components'

export const TileTitle = styled.span`
  font-size: 18px;

  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.title};
  font-weight: ${({ theme }) => theme.fonts.titleWeight};
`
